import ListActions from "./ListActions";
import React from "react";
import { Edit as EditAdmin } from "react-admin";
import { Form } from "./Create";

const Edit = (props: any) => {
  return (
    <EditAdmin
      undoable={false}
      component="div"
      {...props}
      actions={<ListActions />}>
      <Form isEdit />
    </EditAdmin>
  );
};

export default Edit;
